export default {
    private: false,
    slug: 'mandel',
    promo: 'Mandel’s first video ad campaign delivered a 205% ROAS and a path to maximise their future ad spend.',
    meta: {
        title: '250% Increase In ROAS With FOAP Visual Content',
        description: 'Mandel, the boutique apparel label extended both their marketing dollar and brand reach by teaming up FOAP to launch an exploratory video ad campaign!',
        ogImage: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-og.jpg')
    },
    hero: {
        visible: true,
        title: 'Case Study',
        logoHref: 'https://mandel-store.com',
        logo: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-logo.png')
    },
    challenge: {
        visible: true,
        title: 'Aesthetic meets ambition',
        subtitle: 'Mandel began life as a passion project in search of the ultimate balance between aesthetics and functionality. Mandel’s classy, minimalist designs grab the eye without sacrificing functionality, making their creations perfect for any setting, mood or outfit.',
        video: {
            container: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-fbMock-empty.png'),
            poster: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-challenge-videoPoster.jpg'),
            assets: [{
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/webm_w640-foap-case-study-mandel-2.webm',
                type: 'video/webm'
            }, {
                src: 'https://videoscdn.foap.com/frontend-static-assets/case-studies/mp4_w640-foap-case-study-mandel-2.mp4',
                type: 'video/mp4'
            }]
        },
        footer: 'Mandel wanted to increase their brand awareness in key European markets but in a smart and sustainable manner. They decided to test the waters before taking the big plunge.',
        float01: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-challenge-float01.jpg'),
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-challenge-sideBg.svg'),
        ogImage: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-og.jpg')
    },
    solutionv2: {
        visible: true,
        title: 'Kindred spirits',
        subtitle: `
            Sometimes the stars actually align. The stars of the creative world, that is. 
            <br/><br/>
            Instagram has always been Mandel’s go-to social media platform. After all, it’s the home of their buyer persona: 
            European, female, 18-34, engaged shopper. Their branded images had always performed well, but they wanted to further 
            enrich their presence with eye-catching video content. That’s when Mandel turned to Instagram Business and Foap, a 
            crowdsource visual content platform delivering tailor-made video and imagery.
            <br/><br/>
            It was a perfect fit. First, Foap offered a campaign service (Product Sampling Mission) designed to specifically 
            test the market with targeted video content. Second, drawing from Foap’s pool of 3 million creatives, the Foap 
            creative team assembled a sample group of content creators that not only matched Mandel’s brand brief but their 
            overall buyer persona.
            <br/><br/>
            And then the fun began. Mandel watched their mission gallery fill up with video content tailored to their campaign brief, 
            all in real time. Guided by a dedicated Foap curator, Mandel selected the winning video ad with four variations in design 
            and backing-music to be tested on Instagram across multiple European markets. 
            <br/><br/>
            The video ads were exported seamlessly to Instagram through Foap’s content migration console, complete with custom targeting 
            settings. From there it was just a matter of monitoring the metrics.
        `,
        sideBg: require('Theme/images/videoCaseStudies/videoCaseStudy-whyus-sideBg.svg'),
        photo1: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-02.jpg'),
        photo3: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-03.jpg'),
    },
    results: {
        visible: true,
        title: 'Time to get busy',
        video: null,
        textBlock: `
            Instagram Insights allowed Mandel to accurately determine which of the four ad variants performed the 
            best against certain variables (demographics, location, behaviour and interests), as well as identify 
            Lookalike customers to target next. Armed with this data, they can now concentrate their next ad spend 
            into campaigns that only feature the highest performing target settings. In the meantime, over just a 6-day period, 
            their exploratory campaign delivered them: 
        `,
        testimony: {
            title: 'Client testimony:',
            content: '"As a growing brand, we have to make sure that we get the most out of every ad dollar spent. That means finding ad content and a platform that speaks directly to our target group. Foap and Instagram delivered that to us on both fronts. After just 6 days we saw a 250% increase on our ROAS. Not bad!" <br /><br /> Monika Kalicińska, Creator of Mandel',
        },
        list: [{
            styles: { color: '#4AD2FF' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-graph-lines.svg'),
            title: '250%',
            subtitle: 'ROAS in best-performing markets'
        }, {
            styles: { color: '#F5A623' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-rocket.svg'),
            title: '31.84%',
            subtitle: 'higher CTR'
        }, {
            styles: { color: '#50E3C2' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-globe.svg'),
            title: '8,000+',
            subtitle: 'new website visitors'
        }, {
            styles: { color: '#623CC9' },
            icon: require('Theme/images/videoCaseStudies/videoCaseStudy-icon-connection.svg'),
            title: '1,000+',
            subtitle: 'new Instagram followers'
        }],
        photo1: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-results-photo-01.jpg'),
        photo2: require('Theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-results-photo-02.jpg'),
        bgSide: require('Theme/images/videoCaseStudies/videoCaseStudy-results-top.svg')
    },
    checkout: {
        visible: true
    }
};



// WEBPACK FOOTER //
// ./src/containers/global/VideoCaseStudy/data/mandel.js